import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setOptions } from '@googlemaps/js-api-loader';
import { environment } from '@environments/environment';

setOptions({
	key: environment.googleApiKey,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
